import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'


export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectCaseList = (state) => {
    return selectOwnState(state).caseList
}



// WEBPACK FOOTER //
// ./src/modules/threeshape/state/match/selector.js